import { useState, useEffect } from 'react';

export interface Milestone {
  id: string;
  name: string;
  date: string;
  status: string;
  statusColor: string;
}

export interface ProgressActivity {
  id: string;
  user: string;
  action: string;
  time: string;
}

export interface GanttItem {
  id: string;
  name: string;
  progress: number;
  status: 'completed' | 'in-progress' | 'pending' | 'delayed';
  startDate: string;
  endDate: string;
}

export function useProjectProgress() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setData({
        overallProgress: 45,
        ev: 12850000000,
        pv: 18650000000,
        variance: -5800000000,
        variancePercent: -20,
        timeInfo: {
          startDate: '01/04/2024',
          endDate: '30/09/2024',
          totalDays: 182,
          elapsedDays: 45,
          remainingDays: 137,
          varianceDays: -12
        },
        ganttItems: [
          { id: '1', name: '1. San nền và chuẩn bị mặt bằng', progress: 100, status: 'completed', startDate: '2024-04-01', endDate: '2024-04-15' },
          { id: '2', name: '2. Trồng cây xanh', progress: 60, status: 'in-progress', startDate: '2024-04-10', endDate: '2024-05-20' },
          { id: '3', name: '3. Hệ thống tưới tự động', progress: 30, status: 'in-progress', startDate: '2024-04-15', endDate: '2024-06-10' },
          { id: '4', name: '4. Hệ thống chiếu sáng', progress: 10, status: 'in-progress', startDate: '2024-05-01', endDate: '2024-06-15' },
          { id: '5', name: '5. Tiểu cảnh & hồ nước', progress: 0, status: 'pending', startDate: '2024-06-15', endDate: '2024-07-30' },
        ],
        milestones: [
          { id: '1', name: 'Khởi công dự án', date: '01/04/2024', status: 'Hoàn thành', statusColor: 'text-emerald-600' },
          { id: '2', name: 'Hoàn thành san nền', date: '10/04/2024', status: 'Hoàn thành', statusColor: 'text-emerald-600' },
          { id: '3', name: 'Hoàn thành trồng cây xanh', date: '20/05/2024', status: 'Đang thực hiện', statusColor: 'text-blue-600' },
          { id: '4', name: 'Hoàn thành hệ thống tưới', date: '25/05/2024', status: 'Sắp tới', statusColor: 'text-slate-400' },
          { id: '5', name: 'Nghiệm thu giai đoạn 1', date: '30/06/2024', status: 'Sắp tới', statusColor: 'text-slate-400' },
        ],
        activities: [
          { id: '1', user: 'Trần Minh Tuấn', action: 'đã cập nhật tiến độ công việc', time: '15/05/2024 09:20' },
          { id: '2', user: 'Lê Hoàng Nam', action: 'đã hoàn thành công việc', time: '14/05/2024 16:45' },
          { id: '3', user: 'Phạm Văn Tài', action: 'đã tạo công việc mới', time: '14/05/2024 10:15' },
        ]
      });
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { data, isLoading };
}
